import {connect} from 'react-redux'

import type {State} from '../../../../reducers/types'
import {getProjectsReady} from '../../../../selectors'

import NestedBuildTypeProblems from './NestedBuildTypeProblems'

type StateProps = {
  projectsReady: boolean
}

const mapStateToProps = (state: State): StateProps => ({
  projectsReady: getProjectsReady(state),
})
export default connect(mapStateToProps)(NestedBuildTypeProblems)
